import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./style.scss";

class Trigger extends Component {
  static propTypes = {
    className: PropTypes.string,
    isMenuOpen: PropTypes.bool,
    onClick: PropTypes.func.isRequired
  };

  static defaultProps = {
    className: "",
    isMenuOpen: false
  };

  render() {
    const className = classNames("trigger", this.props.className, {
      "trigger--close": this.props.isMenuOpen
    });

    return (
      <button
        className={className}
        onClick={this.props.onClick}
        id="mobile-main-menus-btn"
      >
        <span className={classNames("trigger__line")}>
          <span className="trigger__line__top" />
          <span className="trigger__line__bottom" />
        </span>
      </button>
    );
  }
}

export default Trigger;
